import { useState, useEffect, useRef } from 'react';

import overrideService from '../services/OverrideService';

export function useJobSearchType(originalData) {
  const packageType = localStorage.getItem("packageType");
  const packageTierType = localStorage.getItem("packageTierType");
  const hasInjected = useRef(false);

  const isJobPlugin =
    originalData?.isCareers === true &&
    packageType === "1";

  const isDataLoaded = !!originalData && Object.keys(originalData).length > 0;

  // console.log("useJobSearchType:", { isJobPlugin, packageType, packageTierType, isCareers: originalData?.isCareers, isDataLoaded });


    const injectCSS = async () => {
      if (!isDataLoaded) return;

      if (!isJobPlugin) {
        const existingFallbackCSS = document.querySelector('link[data-fallback-css="true"]');
        if (existingFallbackCSS) {
          existingFallbackCSS.remove();
          hasInjected.current = false;
          // console.log("Removed fallback CSS - not a job plugin");
        }
        return;
      }

      if (hasInjected.current) return;

      const alreadyInjected = document.querySelector('link[data-fallback-css="true"]');
      if (alreadyInjected) {
        hasInjected.current = true;
        return;
      }

      try {
        hasInjected.current = true;

        const override = await overrideService.getOverride();
        const referrerUrl = override ? `${override}` : window.location.origin;

        const cssUrl = `${process.env.REACT_APP_PUBLIC_GATEWAY_URL}/styles/jobsearch?referrer=${referrerUrl}`;

        const linkTag = document.createElement("link");
        linkTag.rel = "stylesheet";
        linkTag.type = "text/css";
        linkTag.href = cssUrl;
        linkTag.setAttribute("data-fallback-css", "true");
        document.head.appendChild(linkTag);
        // console.log("Injected jobsearch.css");
      } catch (error) {
        hasInjected.current = false;
        // console.error("Failed to inject fallback CSS:", error);
      }
    };

    injectCSS();

  return { isJobPlugin, packageType, packageTierType };
}